export enum DatesFilterOptions {
    All = 0,
    ThisMonth = 1,
    NextMonth = 2,
    Custom = 3
}
